import AbstractLayerManager from './AbstractLayerManager';
import Request from '../../Request';

export default class SFCAnalysisLayerManager extends AbstractLayerManager {
	constructor(myKey, instance) {
		super(myKey, instance);
		this.name = "Surface Analysis";
		this.popupName = "Surface Analysis";
		this.options.hasPanRefresh = false;
		this.options.hasAutoRefresh = true;
	}
	
	refreshLayer() {
		this.requestSFCAnalysis();
	}
	
	requestSFCAnalysis() {
		console.log('requestSFCAnalysis called');

		if(this.tasks.fetchSFCAnal === undefined) this.tasks.fetchSFCAnal = new Request({
			url: 'https://api.weatherusa.net/v1/feed/sfcanalysis',
			link: 'cancel',
			timeout: 30000,
			onSuccess: this.handleResp.bind(this),
			onError: this.handleError.bind(this)
		});

		this.tasks.fetchSFCAnal.get();
	}

	handleError(err) {
		console.error(err);
	}
	
	handleResp(resp) {
		if(!this.layer) {
			console.error('Could not find layer for layer ID: ' + this.id);
			return false;
		}
		let sfcAnl = resp.body;
		this.layer.clearLayers();
		
		var frontIconSize = [16, 16];
		var frontIconAnchor = [8, 8];

		// Create smoother lines
		for(let il of sfcAnl.geojson.features) {
			// let still uses Array by reference automatically
			if(il.geometry && il.geometry.type === 'LineString') {
				il.geometry.coordinates = this.getCurvePoints(il.geometry.coordinates);
			}
		}

		L.geoJSON(sfcAnl.geojson, {
			pointToLayer: function(feature, ll) {
			// Handle L and H pressure centers
				switch(feature.properties.title) {
					case 'highs':
					var lhicon = '<span style="color: #0000dd;">H</span>'; break;
					default:
					var lhicon = '<span style="color: #dd0000;">L</span>';
				}
				var myIcon = L.divIcon({
					iconSize: [36, 36],
					className: 'map-marker-pressure-center',
					html: lhicon
				});
				return L.marker(ll, {icon: myIcon});
			},
			style: function(feature) {
				// Handle Front colors
				switch(feature.properties.title) {
					case 'trof': return {"color": "#ff7800", "weight": 3, "opacity": 0.71};
					case 'cold': return {"color": "#0000ff", "weight": 3, "opacity": 1.0};
					case 'warm': return {"color": "#ff0000", "weight": 3, "opacity": 1.0};
					case 'ocfnt': return {"color": "#a300a3", "weight": 3, "opacity": 1.0};
					case 'stnry': return {"color": "#0000ff", "weight": 3, "opacity": 1.0};
				}
			},
			onEachFeature: function(feature, ll) {
				// Handle Front decorations
				switch(feature.properties.title) {
					case 'cold': L.polylineDecorator(ll, {
						  patterns: [ 
							  {offset: 25, repeat: 50, endOffset: frontIconAnchor[0], symbol: L.Symbol.marker({
								  rotate: true, markerOptions: {
									  icon: L.icon({iconUrl:'https://www.weatherusa.net/assets/icons/front_cold.png', iconSize: frontIconSize, iconAnchor: frontIconAnchor})
								   }
							  })}
						  ]
						}).addTo(this.layer);
						break;
					case 'warm': L.polylineDecorator(ll, {
						  patterns: [ 
							  {offset: 25, repeat: 50, endOffset: frontIconAnchor[0], 
							  symbol: L.Symbol.marker({
								  rotate: true, markerOptions: {
									  icon: L.icon({iconUrl:'https://www.weatherusa.net/assets/icons/front_warm.png', iconSize: frontIconSize, iconAnchor: frontIconAnchor})
								   }
							  })}
						  ]
						}).addTo(this.layer);
						break;
					case 'ocfnt': L.polylineDecorator(ll, {
						  patterns: [ 
							  {offset: 8, repeat: 100, endOffset: frontIconAnchor[0], symbol: L.Symbol.marker({
								  rotate: true, markerOptions: {
									  icon: L.icon({iconUrl:'https://www.weatherusa.net/assets/icons/front_cold_ocfnt.png', iconSize: frontIconSize, iconAnchor: frontIconAnchor})
								   }
							  })},
							  {offset: 58, repeat: 100, endOffset: frontIconAnchor[0], symbol: L.Symbol.marker({
								  rotate: true, markerOptions: {
									  icon: L.icon({iconUrl:'https://www.weatherusa.net/assets/icons/front_warm_ocfnt.png', iconSize: frontIconSize, iconAnchor: frontIconAnchor})
								   }
							  })}
						  ]
						}).addTo(this.layer);
						break;
					case 'stnry': L.polylineDecorator(ll, {
						  patterns: [ 
							  {offset: 58, repeat: 100, symbol: L.Symbol.dash({pixelSize: 44, pathOptions: {color: "#ff0000", "weight": 3, "opacity": 0.9}}) },
							  {offset: 8, repeat: 100, endOffset: frontIconAnchor[0], symbol: L.Symbol.marker({
								  rotate: true, markerOptions: {
									  icon: L.icon({iconUrl:'https://www.weatherusa.net/assets/icons/front_cold_stnry.png', iconSize: frontIconSize, iconAnchor: frontIconAnchor})
								   }
							  })},
							  {offset: 58, repeat: 100, endOffset: frontIconAnchor[0], symbol: L.Symbol.marker({
								  rotate: true, markerOptions: {
									  icon: L.icon({iconUrl:'https://www.weatherusa.net/assets/icons/front_warm_stnry.png', iconSize: frontIconSize, iconAnchor: [frontIconAnchor[0], frontIconAnchor[1]+1]})
								   }
							  })}
						  ]
						}).addTo(this.layer);
						break;
				}
			}.bind(this)
		}).addTo(this.layer); // Now add geojson to my layer
	}

	// Stolen from WPC...
	getCurvePoints(pts, tension, isClosed, numOfSegments) {
		var points = [];
		for (i = 0; i < pts.length; i++) {
			points.push([pts[i][0]]);
			points.push([pts[i][1]]);
		}

		pts = points;
		
		// use input value if provided, or use a default value   
		tension = (typeof tension != 'undefined') ? tension : 0.5;
		isClosed = isClosed ? isClosed : false;
		numOfSegments = numOfSegments ? numOfSegments : 16;
	    
		var _pts = [], res = [],    // clone array
		    x, y,           // our x,y coords
		    t1x, t2x, t1y, t2y, // tension vectors
		    c1, c2, c3, c4,     // cardinal points
		    st, t, i;       // steps based on num. of segments
		
		// clone array so we don't change the original
		_pts = pts.slice(0);

		// The algorithm require a previous and next point to the actual point array.
		// Check if we will draw closed or open curve.
		// If closed, copy end points to beginning and first points to end
		// If open, duplicate first points to beginning, end points to end
		if (isClosed) {
			_pts.unshift(pts[pts.length - 1]);
			_pts.unshift(pts[pts.length - 2]);
			_pts.unshift(pts[pts.length - 1]);
			_pts.unshift(pts[pts.length - 2]);
			_pts.push(pts[0]);
			_pts.push(pts[1]);
		}
		else {
			_pts.unshift(pts[1]);   //copy 1. point and insert at beginning
			_pts.unshift(pts[0]);
			_pts.push(pts[pts.length - 2]); //copy last point and append
			_pts.push(pts[pts.length - 1]);
		}

		// ok, lets start...
		// 1. loop goes through point array
		// 2. loop goes through each segment between the 2 pts + 1e point before and after
		for (i=2; i < (_pts.length - 4); i+=2) {
			for (t=0; t <= numOfSegments; t++) {
				// calc tension vectors
				t1x = (_pts[i+2] - _pts[i-2]) * tension;
				t2x = (_pts[i+4] - _pts[i]) * tension;
			
				t1y = (_pts[i+3] - _pts[i-1]) * tension;
				t2y = (_pts[i+5] - _pts[i+1]) * tension;
			
				// calc step
				st = t / numOfSegments;
			
				// calc cardinals
				c1 =   2 * Math.pow(st, 3)  - 3 * Math.pow(st, 2) + 1; 
				c2 = -(2 * Math.pow(st, 3)) + 3 * Math.pow(st, 2); 
				c3 =       Math.pow(st, 3)  - 2 * Math.pow(st, 2) + st; 
				c4 =       Math.pow(st, 3)  -     Math.pow(st, 2);
			
				// calc x and y cords with common control vectors
				x = c1 * _pts[i]    + c2 * _pts[i+2] + c3 * t1x + c4 * t2x;
				y = c1 * _pts[i+1]  + c2 * _pts[i+3] + c3 * t1y + c4 * t2y;
			
				//store points in array
				res.push([x, y]);
			}
		}

		return res;
	}
	
	handleClick(e) {
//		this.inst.forwardedClickHandler(this.id, e, e.target.details);
	}
}
